import { CHUNK_H_M } from "../config/constants";
import { hash } from "../core/rng";

export interface TrailPoint {
    x: number;
    slope: number;
}

const MAX_SLOPE = 0.4;

const signedUnit = (seed: number, salt: number, i: number) => (hash(seed, salt, i) / 2 ** 32) * 2 - 1;

function controlPoint(seed: number, i: number, wiggleAt: (yM: number) => number): TrailPoint {
    return {
        x: signedUnit(seed, 1, i) * wiggleAt(i * CHUNK_H_M),
        slope: signedUnit(seed, 2, i) * MAX_SLOPE,
    };
}

export function trailCurve(seed: number, yM: number, wiggleAt: (yM: number) => number): TrailPoint {
    const i = Math.floor(yM / CHUNK_H_M);
    const t = yM / CHUNK_H_M - i;
    const a = controlPoint(seed, i, wiggleAt);
    const b = controlPoint(seed, i + 1, wiggleAt);
    const h = CHUNK_H_M;
    const t2 = t * t;
    const t3 = t2 * t;

    const x = (2 * t3 - 3 * t2 + 1) * a.x
        + (t3 - 2 * t2 + t) * h * a.slope
        + (-2 * t3 + 3 * t2) * b.x
        + (t3 - t2) * h * b.slope;

    const slope = ((6 * t2 - 6 * t) * a.x + (-6 * t2 + 6 * t) * b.x) / h
        + (3 * t2 - 4 * t + 1) * a.slope
        + (3 * t2 - 2 * t) * b.slope;

    return { x, slope };
}
